import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";

const LoginPage = () => {
  const { login } = useAuth();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const [buttonPressed, setbuttonPressed] = useState(false);

  const [ischecked, setIsChecked] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passError, setPassError] = useState("");
  const [email, setEmail] = useState("m1@mail.com");
  const [pass, setPass] = useState("000000");
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();

  const handleEmailChange = (event) => {
    const email = event.target.value;
    setEmail(email);
    if (email.trim() === "") {
      setEmailError("Email is required");
    } else if (!isValidEmail(email)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };
  const handlePassChange = (event) => {
    const pass = event.target.value;
    setPass(pass);
    if (pass.trim() === "") {
      setPassError("Password is Required");
    } else if (pass.length <= 2) {
      setPassError("Password cannot be of length: " + pass.length);
    } else {
      setPassError("");
    }
  };

  const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  async function handleSignIn() {
    try {
      setbuttonPressed(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/v1/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: email, password: pass }),
        }
      );

      if (response.ok) {
        const { user } = await response.json();
        setbuttonPressed(false);
        login(user);
        navigate("/dashboard");
      } else {
        setErrorMsg("Error signing in");
        setbuttonPressed(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      setErrorMsg(error);
    }
  }
  const handleRoleChange = (event) => {
    const role = event.target.value;
    if (role === "employee") {
      setEmail("e1@mail.com");
    } else if (role === "manager") {
      setEmail("m1@mail.com");
    }
  };
  const handleCheckBox = () => {
    setIsChecked(!ischecked);
  };

  return (
    <>
      <div className="flex h-screen fixed left-0 right-0 top-0 bottom-0 ">
        <div className="w-full bg-white flex justify-center items-center p-10 ">
          <div className="max-w-md  rounded">
            {/* Child div with margin and width */}
            <div className="mx-auto shadow-lg border rounded-lg px-20 py-16">
              <h3 className="mb-4 font-poppins font-bold text-4xl text-[#007FFF]">
                Sign In
              </h3>
              <div>
                <select
                  className="px-3 py-2 border border-black bg-white w-full mb-3 rounded-md"
                  onChange={handleRoleChange}
                >
                  <option value="manager">Manager</option>
                  <option value="employee">Employee</option>
                </select>
              </div>

              <div className="mb-2">
                <label htmlFor="emailinput" className="mb-2 font-poppins">
                  Email
                </label>
                <input
                  className="px-3 py-2 border border-black bg-white w-full mb-3 rounded-md"
                  name="emailinput"
                  type="email"
                  value={email}
                  required
                  onChange={handleEmailChange}
                />
                {emailError && (
                  <span style={{ color: "red" }}>{emailError}</span>
                )}
              </div>

              <div className="passContainer mb-4">
                <label htmlFor="passinput" className="mb-2 font-poppins">
                  Password
                </label>
                <input
                  className="px-3 py-2 border border-black bg-white w-full mb-2 rounded-md"
                  minLength={2}
                  name="passinput"
                  type={ischecked ? "text" : "password"}
                  value={pass}
                  required
                  onChange={handlePassChange}
                />
                <label className="flex gap-2 items-center text-sm font-poppins">
                  <input
                    type="checkbox"
                    id="chck"
                    onClick={handleCheckBox}
                    className="m-0"
                  />
                  <span className="font-poppins">Show Password</span>
                </label>
                {passError && <span style={{ color: "red" }}>{passError}</span>}
              </div>

              {errorMsg && <p className=" py-2 text-red-700">{errorMsg}</p>}

              <div className="mb-2">
                <button
                  type="button"
                  onClick={handleSignIn}
                  className=" text-xl bg-[#007FFF] font-semibold w-full text-center py-2 text-white rounded-lg"
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
